module.exports = __webpack_public_path__ + "img/unsplash_2.2ad094e3.png";